import React from "react";
import TopLeft from "./sections/TopLeft";
import TopCenter from "./sections/TopCenter";
import TopRight from "./sections/TopRight";
import BottomLeft from "./sections/BottomLeft";
import BottomCenter from "./sections/BottomCenter";
import BottomRight from "./sections/BottomRight";
import BottomOverlay from "./sections/BottomOverlay";
import "./obs.css";

const ObsGame = ({ gameData }) => {
  if (!gameData) return null;

  return (
    <div className="m-0 flex h-screen w-screen items-center justify-center overflow-hidden bg-transparent p-0 font-header">
      <div className="relative m-0 h-full w-full bg-transparent p-0">
        <div className="absolute left-0 right-0 top-0 grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-start gap-4">
          <div className="flex w-full min-w-0 justify-start">
            <TopLeft gameData={gameData} />
          </div>
          <div className="flex justify-center">
            <TopCenter gameData={gameData} />
          </div>
          <div className="flex w-full min-w-0 justify-end">
            <TopRight gameData={gameData} />
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 flex justify-between bg-hockey-page-bg p-1">
          <BottomOverlay gameData={gameData} />
          <div className="flex flex-1 justify-start">
            <BottomLeft gameData={gameData} />
          </div>
          <div className="flex flex-1 justify-center">
            <BottomCenter gameData={gameData} />
          </div>
          <div className="flex flex-1 justify-end">
            <BottomRight gameData={gameData} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ObsGame;
